import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

export const userPrefTabs = ['general', 'notifications', 'cash', 'option'] as const;

export type UserPrefTab = (typeof userPrefTabs)[number];

type UserPreferencesNavBarProps = {
  handleTabClick: (tab: UserPrefTab) => void;
  tabSelected: UserPrefTab;
};

export const UserPreferencesNavBar = ({ handleTabClick, tabSelected }: UserPreferencesNavBarProps) => {
  return (
    <div className="list-group border-end" style={{ minWidth: '26%' }}>
      <h3 className="p-3 px-4 text-truncate">Settings</h3>
      <UserPrefNavBarItem tab="general" selectedTab={tabSelected} handleTabClick={handleTabClick} />
      <UserPrefNavBarItem tab="cash" selectedTab={tabSelected} handleTabClick={handleTabClick} />
      <UserPrefNavBarItem tab="option" selectedTab={tabSelected} handleTabClick={handleTabClick} />
      <UserPrefNavBarItem tab="notifications" selectedTab={tabSelected} handleTabClick={handleTabClick} />
    </div>
  );
};

function UserPrefNavBarItem({
  selectedTab,
  tab,
  handleTabClick,
}: {
  selectedTab: UserPrefTab;
  tab: UserPrefTab;
  handleTabClick: (tab: UserPrefTab) => void;
}) {
  const onClick = useCallback(() => handleTabClick(tab), [tab, handleTabClick]);

  return (
    <button
      data-e2e={`${tab}-item`}
      type="button"
      onClick={onClick}
      className={`${selectedTab === tab ? 'active' : ''} list-group-item-action list-group-item`}
    >
      <FormattedMessage id={`userPreferences.tab.${tab}`} />
    </button>
  );
}
